import React from 'react';

import { useComponentSeasonQuery } from '../../redux/ducks/componentSeason';

const withComponentSeasons = (WrappedComponent) => {
    const Wrapper = () => {
        const { data: componentSeason = [] } = useComponentSeasonQuery({});
        return Object.keys(componentSeason).length > 0 ? <WrappedComponent componentSeasons={componentSeason} /> : null;
    };

    return Wrapper;
};

export default withComponentSeasons;
